module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    attrs: {
      "id": "_idParaDest-2"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/preface"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/pt1"
    }
  }, [_c('b', [_vm._v("PART 1: Critical Contexts")])])]), _vm._v(" "), _c('p', {
    staticClass: "body_sa"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch1"
    }
  }, [_vm._v("1 Introduction: Religion and the Discourse of Modernism")])]), _vm._v(" "), _c('p', {
    staticClass: "body_sa"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch2"
    }
  }, [_vm._v("2 H. R. Rookmaaker, "), _c('i', [_vm._v("Modern Art and the Death of a Culture")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/pt2",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("PART 2: Geographies, Histories and Encounters")])])]), _vm._v(" "), _c('p', {
    staticClass: "body_sa"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 France, Britain and the Sacramental Image")])]), _vm._v(" "), _c('p', {
    staticClass: "body_sa"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 Germany, Holland and Northern Romantic Theology")])]), _vm._v(" "), _c('p', {
    staticClass: "body_sa"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 Russian Icons, Dada Liturgies and Rumors of Nihilism")])]), _vm._v(" "), _c('p', {
    staticClass: "body_sa"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 North America and the Expressive Image")])]), _vm._v(" "), _c('p', {
    staticClass: "body_sa"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 North America in the Age of Mass Media")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/afterword",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Afterword: So What? by Daniel A. Siedell")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/illustrations",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Illustrations")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/generalindex",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("General Index")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/scriptureindex",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Scripture Index")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/praise",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Praise for")]), _vm._v(" Modern Art and the Life of a Culture")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/authors",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("About the Authors")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/brandpage",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Studies in Theology and the Arts")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/moreIVP",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("More Titles from InterVarsity Press")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/copyright",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Copyright")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78ee341a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/contents.vue
// module id = 63
// module chunks = 0